// extracted by mini-css-extract-plugin
export default {"container":"menu_container__AzmOc","filters":"menu_filters__lDAuX"};